<template>
    <path d="M38 3.826L22.825 19 38 34.174 34.175 38 19 22.826 3.825 38 0 34.174 15.175 19 0 3.826 3.825 0 19 15.174 34.175 0" fill-rule="evenodd"/>
</template>

<script>
export default {
    name: 'closeIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 38 38');
    }
};
</script>
